module.exports = __webpack_public_path__ + "media/images/flags/de-cfbb0cf09f502653fe85aed9bd14d4ef.svg";